import gsap from "gsap";
import {ScrollTrigger}from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const setupRoadmapAnimations=({
  sectionRef,
  stageRef,
  trackRef,
  itemRefs,
  roadmapItems
})=>{
  const section=sectionRef.current;
  const stage=stageRef.current;
  const track=trackRef.current;
  const items=itemRefs.current;

  if(!section||!stage||!track||!items.length){
    return;
  }

  const ctx=gsap.context(()=>{

    const progressDots=section.querySelectorAll(
      ".roadmap-progress-dot"
    );

    const setActiveItem=(activeIndex)=>{
      items.forEach((item,index)=>{
        if(!item)return;

        item.classList.toggle(
          "is-active",
          index <= activeIndex
        );
      });

      progressDots.forEach((dot,index)=>{
        dot.classList.toggle(
          "is-active",
          index <= activeIndex
        );
      });
    };

    gsap.set(track, { clearProps: "all" });
    
    const triggers = [];
    
    items.forEach((item, index) => {
      if (!item) return;
      
      const st = ScrollTrigger.create({
        trigger: item,
        start: "top 70%",
        end: "bottom 30%",
        onEnter: () => setActiveItem(index),
        onEnterBack: () => setActiveItem(index),
      });
      
      triggers.push(st);
    });

    // Initial active state
    setActiveItem(0);

    return () => {
      triggers.forEach(t => t.kill());
    };

  },section);

  return()=>{
    ctx.revert();
  };
};